export const bedroomsOptions = ['', '1', '2', '3', '4', '5'];
